import { Trans, useLingui } from '@lingui/react/macro'

import { H2 } from '../../_components/H2'
import { PrimaryButton } from '../../_components/PrimaryButton'

import LazyImage from '@/components/LazyImage'

export const VariousGenres: React.FC = () => {
  const { t } = useLingui()

  return (
    <div className='mx-auto flex max-w-[1104px] flex-col items-center gap-3 px-4 md:flex-row md:gap-[105px]'>
      <div className='flex flex-1 flex-col items-center '>
        <span
          style={{
            background:
              'linear-gradient(360deg, rgba(201, 175, 255, 0.2) 0%, rgba(121, 105, 153, 0.2) 100%)',
          }}
          className='text-f-other-9 mx-auto block w-fit rounded-full border border-[#C9AFFF33] px-5 py-1.5 text-xs md:mx-0 md:text-sm'
        >
          <Trans>Versatile & Dynamic</Trans>
        </span>
        <div className='flex flex-col items-center md:items-start'>
          <H2 className='pt-3 text-center md:pt-6 md:text-start'>
            <Trans>Explore Professional Music Controls</Trans>
          </H2>
          <p className='text-f-other-10 pt-2 text-sm md:pt-3 md:text-xl'>
            <Trans>
              Tad AI music generator offers a diverse range of style options and
              advanced music settings. You can craft music that fits your
              project perfectly. The possibilities are endless!
            </Trans>
          </p>
          <PrimaryButton href='/ai-music-generator' className='mt-6 md:mt-9'>
            <Trans>Try AI Music Generator</Trans>
          </PrimaryButton>
        </div>
      </div>
      <LazyImage
        width={509}
        height={320}
        src={'/images/index/explore-various.png?t=1'}
        alt={t`Explore Various Genres And Moods`}
      />
    </div>
  )
}
